// @ts-nocheck
import { useEffect, useState } from 'react';

import {
  UserPlus,
  Link,
  MagnifyingGlass,
  SquaresFour,
  Users,
} from '@phosphor-icons/react';
import { Text, XStack, YStack } from 'tamagui';

import { Header, Footer } from '../components/landing';
import { SubscribeForm } from '../components/landing/SubscribeForm';

const STEPS = [
  {
    icon: UserPlus,
    title: 'Sign up',
    description:
      'Create your account in seconds. The free tier includes core search, built-in apps, and 3 connected integrations. No credit card required.',
  },
  {
    icon: Link,
    title: 'Connect your apps',
    description:
      'One-click OAuth for Gmail, Slack, Notion, Google Drive, GitHub, and 50+ other tools. Free tier gets 3 apps — upgrade anytime for unlimited.',
  },
  {
    icon: MagnifyingGlass,
    title: 'Search',
    description:
      'Type in the search bar and find anything across all your connected tools instantly. Results are permissions-aware — you only see what you have access to.',
  },
  {
    icon: SquaresFour,
    title: 'Try the built-in apps',
    description:
      'Open Kanban, Calendar, Docs, Wiki, OKRs, or Sprints from the sidebar. Everything is included with your account — no extra setup, no extra cost.',
  },
  {
    icon: Users,
    title: 'Invite your team',
    description:
      'On Pro or Team plans, add teammates to your workspace. They get the same unified search and built-in apps, with shared permissions and admin controls.',
  },
];

export default function GettingStartedPage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <YStack backgroundColor="$background" minHeight="100vh">
      <Header />

      <YStack paddingTop={140} paddingHorizontal="$5" gap="$8" paddingBottom={80}>
        <YStack maxWidth={800} alignSelf="center" width="100%">
          {/* Page header */}
          <YStack marginBottom={48}>
            <Text
              fontSize={isMobile ? 30 : 44}
              fontWeight="700"
              letterSpacing={-1.5}
              lineHeight={isMobile ? 36 : 52}
              color="$color12"
            >
              Getting Started
            </Text>
            <Text fontSize={16} color="$color10" lineHeight={26} marginTop="$3">
              From sign-up to searching everything in under five minutes.
            </Text>
          </YStack>

          {/* Steps */}
          <YStack gap="$7">
            {STEPS.map((step, index) => {
              const IconComponent = step.icon;
              return (
                <XStack
                  key={step.title}
                  gap="$5"
                  alignItems="flex-start"
                  flexDirection={isMobile ? 'column' : 'row'}
                >
                  <XStack gap="$4" alignItems="center" flexShrink={0}>
                    <XStack
                      width={48}
                      height={48}
                      borderRadius="$4"
                      alignItems="center"
                      justifyContent="center"
                      style={{ backgroundColor: 'rgba(255, 255, 255, 0.06)' }}
                    >
                      <IconComponent size={24} color="#ededed" />
                    </XStack>
                    <Text
                      fontSize={14}
                      fontWeight="700"
                      color="#ededed"
                      style={{ fontVariantNumeric: 'tabular-nums' } as any}
                    >
                      {String(index + 1).padStart(2, '0')}
                    </Text>
                  </XStack>
                  <YStack gap="$1" flex={1}>
                    <Text fontSize={20} fontWeight="600" color="$color12" letterSpacing={-0.3}>
                      {step.title}
                    </Text>
                    <Text fontSize={15} color="$color10" lineHeight={26}>
                      {step.description}
                    </Text>
                  </YStack>
                </XStack>
              );
            })}
          </YStack>

          {/* CTA */}
          <YStack alignItems="center" marginTop={64} gap="$4">
            <Text fontSize={24} fontWeight="600" color="$color12" letterSpacing={-0.5} textAlign="center">
              Ready to try Torch?
            </Text>
            <Text fontSize={15} color="$color9" textAlign="center">
              Join the waitlist and be the first to know when we launch.
            </Text>
            <SubscribeForm />
          </YStack>
        </YStack>
      </YStack>

      <Footer />
    </YStack>
  );
}
